import { gql } from "@apollo/client";

export const CART_DETAILS_QUERY = gql`
  query cartDetailsQuery($cart_id: String!) {
    cart(cart_id: $cart_id) {
      ln_fe {
        fe_firstname
        fe_lastname
        fe_email
        fe_job_title
        fe_is_admin
        __typename
      }
      id
      custom_attributes {
        ln_sl_noattorney
        ln_sl_package_type
        ln_sl_subscription_type
        ln_sl_subscription_year
        ln_sl_subscription_month
        ln_job_title
        __typename
      }
      total_quantity
      email
      is_virtual
      applied_coupon {
        code
        __typename
      }
      prices {
        discount {
          label
          amount {
            currency
            value
            __typename
          }
          __typename
        }
        subtotal_including_tax {
          currency
          value
          __typename
        }
        subtotal_excluding_tax {
          value
          __typename
        }
        subtotal_with_discount_excluding_tax {
          value
          __typename
        }
        applied_taxes {
          label
          amount {
            value
            currency
            __typename
          }
          __typename
        }
        grand_total {
          value
          currency
          __typename
        }
        __typename
      }
      items {
        id
        uid
        quantity
        product {
          id
          uid
          sku
          name
          url_key
          short_description {
            html
            __typename
          }
          ln_sl_usc_feature_pdf
          ln_sl_inclusion_overview
          stock_status
          __typename
        }
        prices {
          price {
            currency
            value
            __typename
          }
          __typename
        }
        ... on BundleCartItem {
          bundle_options {
            uid
            label
            type
            values {
              id
              label
              price
              quantity
              __typename
            }
            __typename
          }
          customizable_options {
            customizable_option_uid
            id
            label
            type
            values {
              customizable_option_value_uid
              id
              label
              value
              price {
                value
                units
                type
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        ... on VirtualCartItem {
          customizable_options {
            customizable_option_uid
            id
            label
            type
            values {
              customizable_option_value_uid
              id
              label
              value
              price {
                value
                units
                type
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      billing_address {
        firstname
        lastname
        company
        street
        city
        region {
          region_id
          code
          label
          __typename
        }
        postcode
        telephone
        country {
          code
          label
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const CHECK_IS_USER_AUTH = gql`
  query checkUserIsAuthed($cartId: String!) {
    cart(cart_id: $cartId) {
      id
      __typename
    }
  }
`;
